import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, CardMedia, Box, Typography, CircularProgress, Button } from '@mui/material';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { primaryColor } from '../theme';

const PublicContentDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/content/${id}`);
        setContent(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching content:', error);
        setError('Content not found');
        setLoading(false);
      }
    };

    fetchContent();
  }, [id]);

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Typography variant="h6" color="error">{error}</Typography>;
  }

  const getPresentationEmbedUrl = (url) => {
    if (url.endsWith('.pptx')) {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
    }
    return url;
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Helmet>
      <meta property="og:url"                content="http://www.nytimes.com/2015/02/19/arts/international/when-great-minds-dont-think-alike.html" />
      <meta property="og:type"               content="article" />
      <meta property="og:title"              content="When Great Minds Don’t Think Alike" />
      <meta property="og:description"        content="How much does culture influence creative thinking?" />
      <meta property="og:image"              content="http://static01.nyt.com/images/2015/02/19/arts/international/19iht-btnumbers19A/19iht-btnumbers19A-facebookJumbo-v2.jpg" />
      </Helmet>
      <Box>
      <Typography variant="h4" gutterBottom style={{ color: primaryColor }}>
        {content.topic}
      </Typography>
      {/* <Typography variant="subtitle1" gutterBottom>
        {content.targetUser} - {content.valueChain}
      </Typography> */}
      {content.video && (
        <Box mt={2}>
          <CardMedia
            component="video"
            controls
            height="200"
            src={content.video}
            title={content.topic}
          />
        </Box>
      )}
      {content.audio && (
        <Box mt={2}>
          <audio controls>
            <source src={content.audio} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        </Box>
      )}
      {content.presentation && (
        <Box mt={2}>
          <iframe
            src={getPresentationEmbedUrl(content.presentation)}
            width="100%"
            height="400"
            title={content.topic}
            frameBorder="0"
            allowFullScreen
          />
        </Box>
      )}
      <Typography variant="body1" dangerouslySetInnerHTML={{ __html: content.content }} />
      <Box mt={2} mb={4} display="flex" gap={2}>
      </Box>
    </Box>

    </Container>
  );
};

export default PublicContentDetail;